<template>
  <div class="weekly-trend-insight">
    <div>
      <ai-breadcrumb />
      <div class="new-button">
        <guide class="guide-button" />
      </div>
    </div>
    <div class="toolbar">
      <el-form @submit.native.prevent :inline="true" size="small" class="search-form">
        <el-form-item class="search-form-gutter" :label="$t('analysis.date')">
          <el-select style="width: 128px" v-model="currentDate" filterable>
            <el-option v-for="item in dateList" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="download-btn">
        <el-button size="small" class="excel-dl-btn" icon="el-icon-download" @click="downloadReport">{{
          $t("common.download") }}</el-button>
      </div>
    </div>
    <iframe v-if="src" style="border: 0" :src="src | ossUrl" width="100%" height="1000px"></iframe>
  </div>
</template>

<script>
import AiBreadcrumb from "@/components/AiBreadcrumb";
import { fetchWeeklyDates, fetchWeekly } from "@/api/trend-insight";
import Guide from "@/components/Guide";
import { downloadFile } from "@/utils/download-file";
import { ossUrl } from "@/filters/index";
import { getLanguage } from "@/lang/index";

export default {
  components: {
    AiBreadcrumb,
    Guide,
  },
  data() {
    return {
      currentDate: null,
      dateList: [],
      src: "",
    };
  },
  created() {
    this.fetchDateList();
  },
  methods: {
    fetchData() {
      if (!this.currentDate) {
        return;
      }
      fetchWeekly({ date: this.currentDate }).then((response) => {
        this.src = response && response.result ? response.result.url : "";
      });
    },
    fetchDateList() {
      fetchWeeklyDates().then((response) => {
        if (response.success) {
          this.dateList = response.result.items || [];
          if (this.dateList && this.dateList.length > 0) {
            this.currentDate = this.dateList[0];
          }
        }
      });
    },
    downloadReport() {
      downloadFile(ossUrl(this.src), `weekly_trend_insight_${this.currentDate}_${getLanguage()}.html`);
    }
  },
  watch: {
    currentDate() {
      this.fetchData();
    },
  },
};
</script>

<style lang="scss" scoped>
.weekly-trend-insight {
  .new-button {
    text-align: right;
    width: 100%;
    margin: 10px 0;
  }

  .toolbar {
    background-color: #fff;
    padding: 10px;
    width: 100%;
    margin-bottom: 10px;
    text-align: right;

    .el-form-item {
      margin-bottom: 0;
    }

    .search-form {
      float: left;
      width: auto;

      .search-form-gutter {
        margin-right: 30px;
      }
    }

    .download-btn {
      display: inline-block;
    }

    .download-btn.hidden {
      visibility: hidden;
    }
  }
}
</style>